import { ChangeDetectorRef, Component, NgZone } from '@angular/core';
import { MessagingService } from './core/_services/messaging.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Service Galaxy Customer';
  message: any;
  constructor(private messagingService: MessagingService){
    this.messagingService.requestPermission()
    this.messagingService.receiveMessage()
    this.message = this.messagingService.currentMessage
  }
  ngOnInit(){
    this.loadGoogleMaps();
  }
  loadGoogleMaps() {
    const scriptId = 'google-maps-script';
    if (document.getElementById(scriptId)) {
      return;
    }

    const script = document.createElement('script');
    script.id = scriptId;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&libraries=places&language=en`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }
}
